import { useDispatch, useSelector } from "react-redux"
import { setOpenChoiceComponentAR, setOpenMainMenu, setOpenModalAddCity } from "../Reducer/ModalSlice"
import { useState } from "react"
import axios from "axios"
import { IoClose } from "react-icons/io5"
import { FaCheck } from "react-icons/fa6";


function AddCityModalWindow() {
    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)

    const OpenModal = useSelector(state => state.ModalSlice.OpenModal)

    const dispatch = useDispatch()

    const [CityAdress, setCityAdress] = useState('')    
    const [CityCheck, setCityCheck] = useState('')
    const [CancelTouch, setCancelTouch] = useState(false)
    const [isLoading, setLoading] = useState(true)
    const [SuscessLoading, setSuscessLoading] = useState(false)

    const handleClickSaveButton = async (event) => {
        setLoading(false)
        if(event.type === 'touchend')
            event.preventDefault()

        if(CityAdress === '')
        {
            setLoading(true)
            return(alert('Не введен адресс'))
        }
        
        if(CityCheck === '')
        {
            setLoading(true)
            return(alert('Не введен город'))
        }
        
        var NewCity = ''
        var ArrayCity = ''
        
        await axios.post(Server + 'cities', {           
                Adress: CityAdress,
                City: CityCheck
        }, {
            headers: {
            Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((response) => {
            setSuscessLoading(true)
            NewCity = response.data
        })
        .catch(() => {
            setSuscessLoading(false)
            return(
                alert('Произошла ошибка, обновите страницу и повторите попытку')
            )
        })        

        await axios.get(Server + 'citiesrevenues?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((response) => {
            ArrayCity = response.data
        })

        ArrayCity = ArrayCity.filter((el) => el.idCity === ArrayCity[ArrayCity.length - 1].idCity)

        await ArrayCity.map(async (el) => {
            var Day = ''
            if(el.MonthValue >= parseInt(new Date().getMonth() + 1))
                {
                    if(el.MonthValue === 1 || el.MonthValue === 3 || el.MonthValue === 5 || el.MonthValue === 7 || el.MonthValue === 8 || el.MonthValue === 10 || el.MonthValue === 12) 
                    {
                        Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                    }
                    else
                    {
                        if(el.MonthValue === 2)
                        {
                            if(el.YearValue % 4 === 0 && (el.YearValue % 100 !== 0 || el.YearValue % 400 === 0)) 
                            {
                                Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                            }
                            else
                            {
                                Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                            }
                        }
                        else
                        {
                            Day = '0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0_0'
                        }
                    }
                
                    return(axios.post(Server + 'citiesrevenues', {
                    idCity: NewCity.id,
                    Revenue: Day,
                    Percent: '0_0_0_0_0_0_0_0',
                    YearValue: el.YearValue,
                    MonthValue: el.MonthValue
                }, {
                    headers: {
                    Authorization: 'Bearer ' + User.jwt,
                    },
                })
                .then(() => {
                    setSuscessLoading(true)
                })
                .catch(() => {
                    setSuscessLoading(false)
                    return(
                        alert('Произошла ошибка, обновите страницу и повторите попытку')
                    )
                }))             
        }
            
        })

        await axios.get(Server + 'cityadvancereports?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((response) => {
            ArrayCity = response.data
        })

        ArrayCity = ArrayCity.filter((el) => el.idCity === ArrayCity[ArrayCity.length - 1].idCity)

        ArrayCity.map((el) => {
            return (
                axios.post(Server + 'cityadvancereports', {
                idCity: NewCity.id,
                YearValue: el.YearValue,
                MonthValue: el.MonthValue,
                Articles: [],
                AdminArticles: [],
                ResponsiblesUsers: {
                    ManagerName: "",
                    AccountantName: ""
                },
                BlockEdit: false
            }, {
                headers: {
                Authorization: 'Bearer ' + User.jwt,
                },
            })
            .then(() => {
                setSuscessLoading(true)
            })
            .catch(() => {
                setSuscessLoading(false)
                return(
                    alert('Произошла ошибка, обновите страницу и повторите попытку')
                )
            }) 
        )
        })

        await axios.get(Server + 'cities?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            },
        })
        .then((response) => {
            let CityCheker = response.data

            axios.get(Server + 'citiesrevenues?_limit=-1', {
                headers: {
                    Authorization: 'Bearer ' + User.jwt,
                },
            })
            .then((responseRevenue) => {
                let DataRevenue = responseRevenue.data
                let Chekeri = 6
                if(DataRevenue.length < 6)
                {
                    Chekeri = DataRevenue.length - 1
                }
                for (var i = 1; i < Chekeri; i++)
                {
                    let CityChekerId = CityCheker[CityCheker.length - i].id
                    let Cheker = DataRevenue.filter((a) => a.idCity === CityChekerId)
                    if(Cheker.length === 0)
                    {
                        axios.delete(Server + "cities/" + CityChekerId, {
                            headers: {
                                Authorization: 'Bearer ' + User.jwt,
                            },
                        })
                    }
                }
            })
        })            
        setLoading(true)
        setTimeout(() => {            
            if(OpenModal.SelectedSystem === 'FOT')
                dispatch(setOpenMainMenu(true))
    
            if(OpenModal.SelectedSystem === 'AR')
                dispatch(setOpenChoiceComponentAR(true))

            dispatch(setOpenModalAddCity(false))
        }, 500)        
    }

    if(!isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigSpin"
                />
            </div>
        )

    if(SuscessLoading && isLoading)
        return(
            <div
            className="ModalGlobalDiv"
            >
                <div
                className="BigCheckDiv"
                >
                    <FaCheck className="BigCheckIcon"/>
                </div>
            </div>
        )

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div>

                    </div>
                    <div
                    className="ModalInformationTextDiv"
                    >
                        Добавление нового филиала
                    </div>
                    
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() =>{
                        setCityAdress('')
                        if(OpenModal.SelectedSystem === 'FOT')
                            dispatch(setOpenMainMenu(true))
                
                        if(OpenModal.SelectedSystem === 'AR')
                            dispatch(setOpenChoiceComponentAR(true))

                        dispatch(setOpenModalAddCity(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            setCityAdress('')
                            if(OpenModal.SelectedSystem === 'FOT')
                                dispatch(setOpenMainMenu(true))
                    
                            if(OpenModal.SelectedSystem === 'AR')
                                dispatch(setOpenChoiceComponentAR(true))

                            dispatch(setOpenModalAddCity(false))
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>

                <div
                className="InputModalMainDiv"
                >
                    <div
                    className="InputModalTextDiv"
                    >
                    {'Город:'} 
                    </div>
                    <input
                    className="InputModal AddCity"
                    id={'InputModal AddCity'}
                    value={CityCheck}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(() => {
                        if(!CancelTouch)
                            document.getElementById('InputModal AddCity').focus()
                    })}
                    onChange={((e) => {
                        setCityCheck(e.target.value)
                    })}
                    />
                </div>  

                <div
                className="InputModalMainDiv"
                >
                    <div
                    className="InputModalTextDiv"
                    >
                    {'Адресс филиала:'} 
                    </div>
                    <input
                    className="InputModal AddAdress"
                    id={'InputModal AddAdress'}
                    value={CityAdress}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(() => {
                        if(!CancelTouch)
                            document.getElementById('InputModal AddAdress').focus()
                    })}
                    onChange={((e) => {
                        setCityAdress(e.target.value)
                    })}
                    />
                </div>          
                    
                <div
                className="ModalButtonsDiv"
                >
                    <button
                    className="ModalButton Cancle"
                    onClick={(() => {
                        setCityAdress('')

                        if(OpenModal.SelectedSystem === 'FOT')
                            dispatch(setOpenMainMenu(true))
                
                        if(OpenModal.SelectedSystem === 'AR')
                            dispatch(setOpenChoiceComponentAR(true))

                        dispatch(setOpenModalAddCity(false))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            setCityAdress('')

                            if(OpenModal.SelectedSystem === 'FOT')
                                dispatch(setOpenMainMenu(true))
                    
                            if(OpenModal.SelectedSystem === 'AR')
                                dispatch(setOpenChoiceComponentAR(true))

                            dispatch(setOpenModalAddCity(false))
                        }
                    })}
                    >
                        Отмена
                    </button>

                    <button
                    className="ModalButton Save"
                    onClick={handleClickSaveButton}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            handleClickSaveButton(event)
                    }}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default AddCityModalWindow;
